import { render } from "./BackgroundWrapper.vue?vue&type=template&id=7569f89c&scoped=true&ts=true"
import script from "./BackgroundWrapper.ts?vue&type=script&lang=ts"
export * from "./BackgroundWrapper.ts?vue&type=script&lang=ts"

import "./BackgroundWrapper.scss?vue&type=style&index=0&id=7569f89c&lang=scss&scoped=true"

import exportComponent from "/Users/koenverbruggen/Sites/02-SITES/nederlandsmijnmuseum.local/wp-content/themes/nmm/js/vue/nmm/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7569f89c"]])

export default __exports__